<template>
  <div>
    <p>
      {{ label }}
    </p>
    <input
      class=""
      list="datalistOptions"
      style="
        max-width: 12rem;
        width: 192px;
        height: 2.375rem;
        font-size: 0.875rem;
        border: 2px solid rgb(255, 255, 255);
        box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px;
        color: rgb(95, 95, 95);
      "
      name="commonTextInputList"
      :placeholder="disableText"
      v-model="selected"
    />
    <datalist id="datalistOptions">
      <option v-for="(option, index) in options" :data-value="option.text">
        {{ option.text }}
      </option>
    </datalist>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    disableText: {
      type: String,
    },
    disableValue: {
      default: null,
    },
    options: {
      type: Array,
      default: [],
    },
  },
  emits: ["update:getValue"],
  setup(props, { emit }) {
    const selected = ref("");

    if (props.disableValue !== null) {
      selected.value = props.disableValue;
      emit("update:getValue", selected.value);
    } else {
      selected.value = "";
    }

    console.log("disableText >>" + props.disableText);

    watch(
      selected,
      (newValue) => {
        if (props.options && props.options.length > 0) {
          const selectedOption = props.options.find(
            (option) => option.text === newValue
          );
          if (selectedOption) {
            emit("update:getValue", selectedOption.value);
          } else {
            emit("update:getValue", newValue);
          }
        } else {
          emit("update:getValue", newValue);
        }
      },
      { deep: true }
    );

    watch(
      () => props.options,
      (newValue) => {
        if (props.disableValue !== null) {
          selected.value = props.disableValue;
        } else {
          selected.value = "";
        }
      },
      { deep: true }
    );

    return {
      selected,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
}
input {
  max-width: 12rem;
  height: 2.375rem;
  font-size: 0.875rem;
  border: 2px solid rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px;
  color: rgb(95, 95, 95);
  padding: 0.375rem 0.75rem;
}
input:focus {
  outline-width: 0;
}
</style>
